export default "__VITE_ASSET__Du5A0zgy__"